<template>
  <div>
    <v-container class="p-2">
      <OverlayPageVue :showOverlay="loader" />
      <v-card flat class="pb-5">
        <v-row no-gutters>
          <v-col cols="2" class="m-auto">
            <img
              src="../../../assets/master_logo.png"
              alt="QQPay"
              style="max-height: 80px; max-width: 160px"
            />
          </v-col>
          <v-col cols="4">
            <p class="font-weight-bold ma-0 pa-0">QQ Pay Sdn Bhd</p>
            <p class="ma-0 pa-0">
              Level 20, Menara 1 Sentrum, 201, Jalan Tun Sambanthan,
              <br />
              Brickfields,50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
            </p>
            <a href="https://www.qqpay.my/" target="_blank">www.qqpay.io</a>
          </v-col>
          <v-col cols="3">
            <p class="ma-0 pa-0">
              PIN NUMBER:<span class="font-weight-bold">
                {{ txnDetail.pin_umber }}</span
              >
            </p>
            <p class="ma-0 pa-0">
              Transaction ID:<span class="font-weight-bold">
                {{ txnDetail.txn_id }}</span
              >
            </p>
            <p>Transaction Date: {{ txnDetail.txn_date }}</p>
            <!-- <p class="ma-0 pa-0">
          Cash Pickup Pin Number:<span class="font-weight-bold">{{
            55154141
          }}</span>
        </p> -->
          </v-col>
          <v-col cols="2" class="mt-3">
            <v-btn
              @click="showReceipt()"
              color="primary"
              title="View & Download Reciept"
              >Txn Report</v-btn
            >
          </v-col>
        </v-row>
        <v-divider class="pa-0 m-auto" style="width: 95%"></v-divider>
        <v-simple-table style="width: 95%" class="m-auto mb-4 pa-2">
          <tr>
            <td
              colspan="4"
              class="pa-2 white--text font-weight-bold pa-1 bg-primary"
            >
              Transaction Status:<span
                class="font-weight-bold text-uppercase"
                >{{ txnDetail.txn_status }}</span
              >
            </td>
          </tr>
          <!-- <tr>
        <td>Payout Partner</td>
        <td class="font-weight-bold">: {{ 451515 }}</td>
      </tr>
      <tr>
        <td>Transaction Type</td>
        <td class="font-weight-bold">: {{ 7451515 }}</td>
      </tr>
      <tr>
        <td>Operator Name</td>
        <td class="font-weight-bold">: {{ 441741 }} -{{ 425424 }}</td>
      </tr>
      <tr>
        <td>Approved By</td>
        <td class="font-weight-bold">: {{ 444 }} -{{ 54414 }}</td>
      </tr> -->
        </v-simple-table>
        <v-expansion-panels
          color="primary"
          style="width: 95%"
          class="m-auto elevation-0"
          elevation="0"
          multiple
          dense
          focusable
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="font-weight-bold">Sender Information</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              ><v-form>
                <table style="width: 100%">
                  <tr>
                    <td>Sender Name</td>
                    <td>
                      <span class="font-weight-bold">{{
                        senderData.middle_name
                          ? senderData.first_name +
                            " " +
                            senderData.middle_name +
                            " " +
                            senderData.last_name
                          : senderData.last_name
                          ? senderData.first_name + " " + senderData.last_name
                          : senderData.first_name
                      }}</span>
                    </td>
                    <td>Customer ID</td>
                    <td>
                      <span class="font-weight-bold">
                        {{ senderData.customer_id }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>User ID</td>
                    <td class="font-weight-bold">{{ senderData.user_id }}</td>
                    <td>Address</td>
                    <td class="font-weight-bold">
                      <span>
                        {{ senderData.address ? senderData.address : "" }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>User Type</td>
                    <td class="font-weight-bold">
                      <span> {{ senderData.user_type }} </span>
                    </td>

                    <td>Kyc</td>
                    <td>
                      <span class="font-weight-bold">{{
                        senderData.kyc ? senderData.kyc : ""
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>ID type</td>
                    <td>
                      <span class="font-weight-bold">{{
                        senderData.id_type && senderData.id_type.value
                          ? senderData.id_type.value
                          : ""
                      }}</span>
                    </td>
                    <td>ID Number</td>
                    <td class="font-weight-bold">
                      <span>
                        {{ senderData.id_number ? senderData.id_number : null }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Issue Date</td>
                    <td class="font-weight-bold">
                      <span>
                        {{
                          senderData.issue_date ? senderData.issue_date : null
                        }}
                      </span>
                    </td>
                    <td>Expiry Date</td>
                    <td class="font-weight-bold">
                      <span>
                        {{
                          senderData.expire_date ? senderData.expire_date : nul
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Issue Country</td>
                    <td class="font-weight-bold">
                      <span>
                        {{
                          senderData.issue_country
                            ? senderData.issue_country
                            : null
                        }}
                      </span>
                    </td>
                    <td>Email Id</td>
                    <td class="font-weight-bold">
                      <span>
                        {{ senderData.email ? senderData.email : null }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Mobile Number</td>
                    <td class="font-weight-bold">
                      <span class="font-weight-bold">{{
                        senderData.mobile ? senderData.mobile : null
                      }}</span>
                    </td>
                    <td>DOB</td>
                    <td class="font-weight-bold">
                      <span>
                        {{ senderData.dob ? senderData.dob : null }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Gender</td>
                    <td class="font-weight-bold">
                      <span>
                        {{
                          senderData.gender
                            ? senderData.gender.toUpperCase() === "MALE"
                              ? "Male"
                              : "Female"
                            : null
                        }}
                      </span>
                    </td>
                    <td>Nationality</td>
                    <td class="font-weight-bold">
                      <span>
                        {{
                          senderData.nationality &&
                          senderData.nationality.nationality
                            ? senderData.nationality.nationality
                            : null
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>occupation</td>
                    <td class="font-weight-bold">
                      <span>
                        {{
                          senderData.occupation
                            ? senderData.occupation.value
                            : null
                        }}
                      </span>
                    </td>
                    <td>employer</td>
                    <td class="font-weight-bold">
                      <span>
                        {{ senderData.employer ? senderData.employer : null }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Source of funds</td>
                    <td class="font-weight-bold">
                      <span>
                        {{
                          senderData.source_of_funds
                            ? senderData.source_of_funds.value
                            : null
                        }}
                      </span>
                    </td>
                  </tr>
                </table></v-form
              >
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="font-weight-bold">Payment Details</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-form>
                <table style="width: 100%">
                  <tr>
                    <td>Amount</td>
                    <td>
                      <span class="font-weight-bold"
                        >$
                        {{
                          txnDetail.transfer_amt ? txnDetail.transfer_amt : ""
                        }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <!-- <td>Is Gst</td>
                <td>
                  <span class="font-weight-bold"> {{}}</span>
                </td> -->
                  </tr>
                  <tr>
                    <td>Txn Date</td>
                    <td>
                      <span class="font-weight-bold">{{
                        paymentData.remarks_data.modified_date
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Remarks</td>
                    <td>
                      <span class="font-weight-bold">
                        {{ paymentData.remarks_data.remarks }}</span
                      >
                    </td>
                  </tr>
                </table></v-form
              >
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <receipt
          :showPaymentDialog="showPaymentDialog"
          @close-dialog="closeDialog"
          :senderData="senderData"
          :txnDetail="txnDetail"
          :paymentData="paymentData"
          val="payIn"
        ></receipt>
        <v-card width="96%" class="m-auto pt-6">
          <v-data-table
            fixed-header
            :headers="headers"
            :items="getTxnNoteDetails"
            hide-default-footer
          >
          </v-data-table>
        </v-card>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import receipt from "./receipt.vue";
import paymentService from "@/services/PaymentService/paymentService.js";
export default {
  data() {
    return {
      showPaymentDialog: false,

      txnDetail: [],
      senderData: [],
      paymentData: [],
      getTxnNoteDetails: [],
      headers: [
        { text: "Txn Id", value: "txn_id" },
        { text: "status", value: "status" },
        { text: "comments", value: "comments" },
        { text: "Posted by", value: "posted_by" },
        { text: "Posted on", value: "posted_date" },
        { text: "Note from", value: "note_type" },
      ],
    };
  },
  components: {
    receipt,
  },
  mounted() {
    this.getPayInTxn();
    this.getTxnNote();
  },
  methods: {
    showReceipt() {
      this.showPaymentDialog = true;
    },
    closeDialog() {
      this.showPaymentDialog = false;
    },
    async getPayInTxn() {
      console.log(this.$route.query.id);
      try {
        const response = await paymentService.getPayInTxn(this.$route.query.id);
        if (response.data && response.data.status_code === 200) {
          console.log(response);
          this.txnDetail = response.data.data[0].txn_data;
          console.log("txn detail", this.txnDetail);
          this.senderData = response.data.data[0].sender_data;
          console.log("sender data", this.senderData);
          this.paymentData = response.data.data[0];
          console.log(this.paymentData);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTxnNote() {
      try {
        const responseData = await paymentService.getTxnNote(
          this.$route.query.id
        );

        if (responseData && responseData.data.status_code === 200) {
          this.getTxnNoteDetails = responseData.data.data;
          console.log("data found", this.getTxnNoteDetails);
        } else {
          this.getTxnNoteDetails = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
// table,
// th,
// td {
//   border-bottom: 1px solid rgb(195, 195, 195);
//   border-collapse: collapse;
//   padding: 5px;
// }
.primary-bg {
  background-color: rgb(230, 228, 228);
}
.v-list-item {
  justify-content: center;
  padding: 0px;
}
.min_width {
  min-width: 300px;
}
th,
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
</style>
